export enum ConfigInitTypes {
    SHOW_CONFIG_INIT_LOADING = "SHOW_CONFIG_INIT_LOADING",
    HIDE_CONFIG_INIT_LOADING = "HIDE_CONFIG_INIT_LOADING",
    REQUEST_LOAD_CONFIG_INIT = "REQUEST_LOAD_CONFIG_INIT",
    SET_CONFIG_INIT_DATA = "SET_CONFIG_INIT_DATA",
}